module.exports = __webpack_public_path__ + "static/media/home_girl.9ffd8ae8.png";